var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.config.InnerStyle)},[_c('span',{style:(_vm.TextStyle)},[_vm._v(_vm._s(_vm.Text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }